import React from 'react';
import './App.css';
import Layout from './components/layout'
import { Grid, Typography } from '@material-ui/core'
import CacheBuster from './components/CacheBuster'
import * as moment from 'moment'

function App() {

  return (
    <CacheBuster>
      {({ loading, isLatestVersion, refreshCacheAndReload }) => {
        if (loading) return null;
        if (!loading && !isLatestVersion) {
          refreshCacheAndReload();
        }

        // refresh everything to get updated data from Protezione Civile
        setTimeout(refreshCacheAndReload, moment.duration(5, 'hour').asMilliseconds())

        return (<div id='App'>
          <Grid container>
            <Grid item xs={12}>
              <Layout />

            </Grid>
            {/* <Grid item xs={12} className='footer'>
            
                  <Typography component="p">
                  I dati rappresentati in questi grafici sono forniti dalla <a href="https://github.com/pcm-dpc/COVID-19">Protezione Civile</a>
                  </Typography>
                </Grid> */}
          </Grid>
        </div>)
      }}
    </CacheBuster>
  );
}

export default App;
